export default "__VITE_ASSET__BAS5POit__"